<template>
  <div class="action download-manuscript" @click="downloadManuscript">
    Download Book
  </div>
</template>

<script>
import Back from "@/modules/Back";

export default {
  name: "DownloadManuscript",
  props: ["book"],
  methods: {
    async downloadManuscript() {
      this.$toasted.show(
        "The manuscript is downloading now. It may take up to a minute. Please don't close this page.",
        {
          icon: "import_contacts",
          position: "bottom-center",
          duration: 5000
        }
      );

      // console.log("download", this.book);
      const response = await Back.downloadBookManuscript(this.book);
    },
    handleClick() {
      this.downloadManuscript();
    }
  }
};
</script>

<style lang="scss" scoped>
.action {
  display: inline-block;
}
.download-manuscript {
  margin: 0;
  margin-top: -6px;
  font-size: 10.5pt !important;
  background: #daedff;
  color: #2196f3;
}
</style>



